export const ADD_CATEGORY      = 'ADD_CATEGORY';
export const SET_CATEGORIES    = 'SET_CATEGORIES';
export const SET_CATEGORY      = 'SET_CATEGORY';
export const UPDATE_CATEGORY   = 'UPDATE_CATEGORY';
export const CATEGORY_INCLUDES = 'CATEGORY_INCLUDES';
